<script>
export default {
    name: 'cQuery',
    props: {
        title: String,
        queryList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            o: {},
            key: null,
            value: null,
            type: 'el-input',
            icon: 'fa fa-ravelry'
        }
    },
    render(createElement) {
        const vm = this
        let options = null
        if (this.o.type === 'el-select') {
            options = this.o.options.map(v => <el-option label={v.label} value={v.value} key={v.value}></el-option>)
        }
        // 定义查询的node节点
        const searchArea =
            <div class='m-search__search'>
                <span class="m-search__des">关键词：</span>
                <el-select v-model={this.key} size="mini" placeholder="请选择关键词" class="m-search__item" clearable on-change={this.onChange}>
                    {this.queryList.map((v, i) => <el-option label={v.label} value={v.value} key={v.value}></el-option>)}
                </el-select>
                {createElement(this.type, {
                    class: 'm-search__item',
                    attrs: {
                        placeholder: this.type === 'el-input' ? '请输入' : '请选择'
                    },
                    props: {
                        clearable: true,
                        size: 'mini',
                        value: this.value,
                        valueFormat: 'yyyy-MM-dd',
                        disabled: !this.key
                    },
                    on: {
                        input(val) {
                            vm.value = val
                        },
                        change(val) {
                            vm.value = val
                        }
                    }
                }, options)}
                <el-button class='m-search__btn' size='mini' type='primary' on-click={this.sendQuery}>查询</el-button>
                <el-button class='m-search__btn' size='mini' type='danger' on-click={this.sendClear}>清空</el-button>
            </div>
        // 定义slot
        const slotArea = this.$scopedSlots.default ? <div class='m-search__slots'>{this.$scopedSlots.default()}</div> : null
        return (
            <div class={{ 'm-search': true, noTitle: !this.title }}>
                <div class='m-search__title'>
                    <i class='icon' class={this.icon} />
                    <span>{this.title}</span>
                </div>
                <div class='m-search__opt'>
                    {searchArea}
                    {slotArea}
                </div>
            </div>
        )
    },
    renderError(createElement, err) {
        return createElement('pre', { style: { color: 'pink' } }, err.stack)
    },
    methods: {
        onChange(val) {
            this.value = null
            const o = this.queryList.find(v => v.value === val) || {}
            this.o = o
            this.type = o.type || 'el-input'
        },
        sendQuery() {
            let conditions = {}
            this.key && this.key.split(',').forEach(k => {
                conditions[k] = this.value
            })
            this.$emit('sendQueryData', conditions)
        },
        sendClear() {
            this.key = null
            this.value = null
            this.$emit('sendQueryData', {})
        }
    }
}
</script>

<style lang="scss" scoped>
.m-search {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    padding: 4px;
    overflow: hidden;
    border-bottom: 4px solid #83d267;
    box-shadow: 0 0 5px 1px rgba(0, 21, 41, 0.08);
    margin-bottom: 10px;
    &__title {
        color: #4a6076;
        font-weight: 600;
    }
    &__des {
        font-size: 14px;
        margin-right: 10px;
        color: #606266;
    }
    &__opt {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    &__item {
        margin-right: 10px;
        width: inherit;
    }
    &__slots {
        margin-left: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/global/CQuery.vue